export const BERLIN_POSITION = {
  lat: 52.516241935383995,
  lng: 13.377478793077442,
}
const BACKGROUND_SIZE = 10 // degrees

export const BG_BORDER_PATH = [
  {
    lat: BERLIN_POSITION.lat - BACKGROUND_SIZE,
    lng: BERLIN_POSITION.lng - BACKGROUND_SIZE,
  },
  {
    lat: BERLIN_POSITION.lat - BACKGROUND_SIZE,
    lng: BERLIN_POSITION.lng + BACKGROUND_SIZE,
  },
  {
    lat: BERLIN_POSITION.lat + BACKGROUND_SIZE,
    lng: BERLIN_POSITION.lng + BACKGROUND_SIZE,
  },
  {
    lat: BERLIN_POSITION.lat + BACKGROUND_SIZE,
    lng: BERLIN_POSITION.lng - BACKGROUND_SIZE,
  },
]
